import React from 'react';
import{ Avatar, Badge, IconButton }  from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { createTheme } from '@mui/material/styles';

const ProfileBadge = withStyles(() => ({}))(Badge);

const theme = createTheme();
const useStyles = makeStyles({
    cameraAlt: {
        position: 'absolute',
        right: '18%',
        bottom: '18%',
        transform: 'scale(1) translate(50%, 50%)',
        transformOrigin: '100% 100%',
        zIndex: '2',
        height: theme.spacing(3.25),
        width: theme.spacing(3.25),
    },
});

const ProfileImage = (props) => {
    const classes = useStyles();
    return (
        <ProfileBadge>
            <IconButton
                onClick={props.handleClick}
                className={classes.cameraAlt}>
                <CameraAltIcon
                    fontSize="small"
                    style={{
                        color: '#9c9292',
                    }}
                />
            </IconButton>
            <Avatar
                alt="Remy Sharp"
                src={props.src}
                sx={{
                    width: 100,
                    height: 100,
                }}
            />
        </ProfileBadge>
    );
};

export default ProfileImage;
